import React from 'react';
import './Contact.css';

const Contact = () => {
  const handleSubmit = (e) => {
    e.preventDefault();
    // Add form submission logic here
  };

  return (
    <>
      <div className="page-header">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <h2>Contact Us</h2>
            </div>
            <div className="col-12">
              <a href="/">Home</a>
              <a href="/contact">Contact Us</a>
            </div>
          </div>
        </div>
      </div>

      <div className="contact wow fadeInUp" data-wow-delay="0.1s">
        <div className="container">
          <div className="section-header text-center">
            <p>Get In Touch</p>
            <h2>For Any Query</h2>
          </div>
          <div className="row">
            <div className="col-md-6">
              <div className="contact-info">
                {/* India Office */}
                <div className="contact-item">
                  <i className="flaticon-address"></i>
                  <div className="contact-text company-heading">
                    <h2>India Office</h2>
                    <h4>Mikan Engineering and Construction Pvt Ltd</h4>
                    <p>Door No.2/165/B, Mikan Complex, Thenkaiprai Road, Chithanthopu, India 629 810</p>
                    <p><a href="tel:+914652207603">Phone: +91 0465 2207603</a></p>
                    <p><a href="tel:+914652207603">Email: sales@mikan-groups.com,
                    info@mikan-groups.com</a></p>

                  </div>
                </div>

                {/* Singapore Office */}
                <div className="contact-item">
                  <i className="flaticon-address"></i>
                  <div className="contact-text company-heading">
                    <h2>Singapore Office</h2>
                    <h4>Mikan Engineering and Construction Pvt Ltd</h4>
                    <p>2 KALLANG AVENUE, #08-16, CT HUB, SINGAPORE-339 407</p>
                    <p><a href="tel:+6590625963">Phone: +65 90625963</a></p>
                    <p><a href="tel:+914652207603">Email: sales@mikan-groups.com,
                    info@mikan-groups.com</a></p>
                  </div>
                </div>

                {/* Ireland Office */}
                <div className="contact-item">
                  <i className="flaticon-address"></i>
                  <div className="contact-text company-heading">
                    <h2>Ireland Office</h2>
                    <h4>Mikan Engineering Limited</h4>   
                                 
                    <p>32 ,Boughlone Way, Bellingham, Portlaoise, Co. Laois, R32 H7DT, Ireland.</p>
                    <p><a href="tel:+353892348345">Phone: +353 896047510</a></p>
                    <p><a href="tel:+914652207603">Email: sales@mikan-groups.com,
                    info@mikan-groups.com</a></p>
                  </div>
                </div>

                {/* Email (keeping this as it might be useful) */}
                
              </div>
            </div>
            <div className="col-md-6">
              <div className="contact-form">
                <div id="success"></div>
                <form onSubmit={handleSubmit} name="sentMessage" id="contactForm" noValidate>
                  <div className="control-group">
                    <input 
                      type="text" 
                      className="form-control" 
                      id="name" 
                      placeholder="Your Name" 
                      required 
                    />
                    <p className="help-block text-danger"></p>
                  </div>
                  <div className="control-group">
                    <input 
                      type="email" 
                      className="form-control" 
                      id="email" 
                      placeholder="Your Email" 
                      required 
                    />
                    <p className="help-block text-danger"></p>
                  </div>
                  <div className="control-group">
                    <input 
                      type="text" 
                      className="form-control" 
                      id="subject" 
                      placeholder="Subject" 
                      required 
                    />
                    <p className="help-block text-danger"></p>
                  </div>
                  <div className="control-group">
                    <textarea 
                      className="form-control" 
                      id="message" 
                      placeholder="Message" 
                      required 
                    ></textarea>
                    <p className="help-block text-danger"></p>
                  </div>
                  <div>
                    <button className="btn" type="submit" id="sendMessageButton">Send Message</button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Contact;